import { Helmet } from "react-helmet";
import Notifications from '../components/Notifications'
import PastNotifications from "../components/PastNotifications";
import { assetUrl } from "../utils/assetUrl";

/*
EVENTS JSON:
    {
        "key": 1,
        "title": "146th Street – Quaker Avenue to Indiana Avenue - Ribbon Cutting Ceremony",
        "timeRange": "9:00AM",
        "dateRange": "Friday 09/05/2025",
        "endDateTime": "2025-09-05 12:00",
        "innerText": "Ribbon Cutting Ceremony for 146th Street – Quaker Avenue to Indiana Avenue"
    }
*/

export default function Events() {
    // const pastEventsList = ["98th Street (Alcove Avenue to Upland Avenue) Groundbreaking"]
    const pic1 = assetUrl('/assets/photos/pic1.jpg')
    const pic2 = assetUrl('/assets/photos/pic2.jpg')
    const pic3 = assetUrl('/assets/photos/pic3.jpg')
    const pic4 = assetUrl('/assets/constructionUpdates/DJI_0952.JPG')
    const pic5 = assetUrl('/assets/constructionUpdates/DJI_0956.JPG')
    const pic6 = assetUrl('/assets/constructionUpdates/DJI_0961.JPG')
    const pic7 = assetUrl('/assets/IMG_0704.JPG')
    const pic8 = assetUrl('/assets/IMG_0706.JPG')
    const pic9 = assetUrl('/assets/IMG_0723.JPG')
    const pic10 = assetUrl('/assets/IMG_0725.JPG')
    const pic11 = assetUrl('/assets/IMG_0730.JPG')
    const pic12 = assetUrl('/assets/IMG_0753.JPG')
    const pic13 = assetUrl('/assets/photos/0C5A0406.jpg')
    const pic14 = assetUrl('/assets/photos/0C5A0411.jpg')
    const pic15 = assetUrl('/assets/photos/0C5A0451.jpg')
    const pic16 = assetUrl('/assets/photos/0C5A0468.jpg')
    const pic17 = assetUrl('/assets/photos/0C5A0474.jpg')
    const pic18 = assetUrl('/assets/photos/34th St. & Milwaukee_Upland Groundbreaking_1.jpg')
    const pic19 = assetUrl('/assets/photos/34th St. & Milwaukee_Upland Groundbreaking_4.jpg')
    const pic20 = assetUrl('/assets/photos/34th St. & Milwaukee_Upland Groundbreaking_5.jpg')
    const pic21 = assetUrl('/assets/photos/34th St. & Milwaukee_Upland Groundbreaking_6.jpg')
    const pic22 = assetUrl('/assets/photos/34th St. & Milwaukee_Upland Groundbreaking_7.jpg')

    return (
        <div>
            <Helmet>
                <meta property="og:description" content="Events reguarding projects the Lubbock 2022 Street Bond Program." />
                <meta property="og:title" content="Events | City of Lubbock Street Bond" />
                <meta property="og:url" content="https://www.lubbock2022streetbond.com/events" />
            </Helmet>
            <div className="flex-shrink-0 modular min-vh-100">
                <img src={assetUrl(`/assets/downtown${Math.floor(Math.random() * 3)}.png`)} className="d-block w-100" style={{ objectFit: "cover", height: "300px" }} alt="Events" />
                <div className="container">
                    <div className='row text-start mt-4'>
                        <h1 className='mb-4' style={{ color: "#00354C" }}>Upcoming Events</h1>
                        <Notifications />
                    </div>
                    <div className='row text-start mt-4'>
                        <h1 style={{ color: "#00354C" }}>Past Events</h1>
                        <PastNotifications />
                        <div className="card mt-3 px-0">
                            <div className="card-header">
                                <h5 className="my-0">34th Street (Milwaukee Avenue to Upland Avenue) Ground Breaking Ceremony 01/21/2026 at 1:30PM</h5>
                            </div>
                            <div className="card-body row">
                                <div className="col-4">
                                    <img src={pic18} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic19} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic20} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic21} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic22} className="p-2 img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3 px-0">
                            <div className="card-header">
                                <h5 className="my-0">Milwaukee Avenue (4th Street to the North City Limits) Groundbreaking Ceremony 11/25/2025 at 1:30 PM.</h5>
                            </div>
                            <div className="card-body row">
                                <div className="col-4">
                                    <img src={pic13} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic14} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic15} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic16} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic17} className="p-2 img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3 px-0">
                            <div className="card-header">
                                <h5 className="my-0">98th Street (Alcove Avenue to Upland Avenue) Ribbon Cutting Ceremony 09/05/2025 at 10:30 AM.</h5>
                            </div>
                            <div className="card-body row">
                                <div className="col-4">
                                    <img src={pic10} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic11} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic12} className="p-2 img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3 px-0">
                            <div className="card-header">
                                <h5 className="my-0">146th Street (Quaker Avenue to Indiana Avenue) Ribbon Cutting Ceremony 09/05/2025 at 9 AM.</h5>
                            </div>
                            <div className="card-body row">
                                <div className="col-4">
                                    <img src={pic7} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic8} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic9} className="p-2 img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3 px-0">
                            <div className="card-header">
                                <h5 className="my-0">146th Street (Quaker Avenue to Indiana Avenue) Groundbreaking 7/11/2024 at 10 AM.</h5>
                            </div>
                            <div className="card-body row">
                                <div className="col-4">
                                    <img src={pic4} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic5} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic6} className="p-2 img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3 px-0">
                            <div className="card-header">
                                <h5 className="my-0">98th Street (Alcove Avenue to Upland Avenue) Groundbreaking.</h5>
                            </div>
                            <div className="card-body row">
                                <div className="col-4">
                                    <img src={pic1} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic2} className="p-2 img-fluid" alt="" />
                                </div>
                                <div className="col-4">
                                    <img src={pic3} className="p-2 img-fluid" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}